// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProductTypeTagMap } from './product-type-tag-map';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductTypeTag extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(60) */
  name?: string;
  /** Binary */
  rowVersion!: any;
  /** Inv FK productTypeTagId */
  productTypeTagMaps!: ProductTypeTagMap[];
}

